import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagination-page',
  templateUrl: './pagination-page.component.html',
  styleUrls: ['./pagination-page.component.scss']
})
export class PaginationPageComponent implements OnInit {

  public pageIndex: number = 1;
  public totalPages: Array<number> = [1,2,3,4,5];

  public exampleCode: string =
`<!-- Previous Arrow -->
<span class="u-mr--5" *ngIf="pageIndex > 1">
  <a class="say-link say-link--with-icon u-mr--5" (click)="pageIndex = pageIndex - 1">
    <svg class="say-link__icon">
      <use xlink:href="assets/symbols/sprite.svg#arrow_left"></use>
  </svg>
  <span class="say-link__text u-bb--0">Prev</span>
  </a>
</span>

<!-- Next Arrow -->
<span *ngIf="totalPages.length > pageIndex">
  <a class="say-link say-link--with-icon u-ml--5" (click)="pageIndex = pageIndex + 1">
    <span class="say-link__text u-bb--0">Next</span>
    <svg class="say-link__icon">
      <use xlink:href="assets/symbols/sprite.svg#arrow_right"></use>
    </svg>
  </a>
</span>`;

  public pageExampleCode: string = 
`
<!-- Pagination Container -->
    <div *ngIf="totalPages.length > 1" class="say-pagination">

      <!-- Previous Arrow -->
      <span class="u-mr--5" *ngIf="pageIndex > 1">
        <a class="say-link say-link--with-icon u-mr--5" (click)="pageIndex = pageIndex - 1">
          <svg class="say-link__icon">
            <use xlink:href="assets/symbols/sprite.svg#arrow_left"></use>
        </svg>
        <span class="say-link__text u-bb--0">Prev</span>
        </a>
      </span>

      <!-- Pages 
        * NOTE: this only works for a fixed number of pages (~5), and will be ugly with too many pages. 
        * For dynamic implementation you will need to split this out into an element for previous pages, current page, and future pages 
      -->
      <span *ngFor="let page of totalPages">
        <a class="say-pagination--page say-link say-link--no-underline u-mr--5" [class.say-pagination--current]="pageIndex === page" (click)="setPage(page)">{{page}}</a>
      </span>

      <!-- Next Arrow -->
      <span *ngIf="totalPages.length > pageIndex">
        <a class="say-link say-link--with-icon u-ml--5" (click)="pageIndex = pageIndex + 1">
          <span class="say-link__text u-bb--0">Next</span>
          <svg class="say-link__icon">
            <use xlink:href="assets/symbols/sprite.svg#arrow_right"></use>
          </svg>
        </a>
      </span>
      
    </div>
`

  constructor() { }

  ngOnInit() {
  }

  setPage(pageSelection: any) {
    this.pageIndex = pageSelection;
  }

}
